const ET_TIME_ZONE = "America/New_York";
const BEIJING_TIME_ZONE = "Asia/Shanghai";
type DevlogLanguage = "en" | "zh";

function parseDevlogTimestamp(value: string) {
  const normalized = /(?:z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`;
  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function getPart(parts: Intl.DateTimeFormatPart[], type: Intl.DateTimeFormatPartTypes) {
  return parts.find((part) => part.type === type)?.value ?? "";
}

function formatBeijingDate(value: Date) {
  const parts = new Intl.DateTimeFormat("zh-CN", {
    timeZone: BEIJING_TIME_ZONE,
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).formatToParts(value);
  return `${getPart(parts, "year")}.${getPart(parts, "month")}.${getPart(parts, "day")}`;
}

export function formatDevlogDate(value: string, language: DevlogLanguage) {
  const parsed = parseDevlogTimestamp(value);
  if (!parsed) {
    return language === "zh" ? "日期未知" : "Date unavailable";
  }
  if (language === "zh") {
    return formatBeijingDate(parsed);
  }
  return new Intl.DateTimeFormat("en-US", {
    timeZone: ET_TIME_ZONE,
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(parsed);
}

export function formatDevlogClock(value: string, language: DevlogLanguage) {
  const parsed = parseDevlogTimestamp(value);
  if (!parsed) {
    return language === "zh" ? "时间未知" : "Time unavailable";
  }
  if (language === "zh") {
    const time = new Intl.DateTimeFormat("zh-CN", {
      timeZone: BEIJING_TIME_ZONE,
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).format(parsed);
    return `北京时间 ${time}`;
  }
  const time = new Intl.DateTimeFormat("en-US", {
    timeZone: ET_TIME_ZONE,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(parsed);
  return `${time} ET`;
}
